export default __webpack_public_path__ + "8da2aa6d766916c06a9bbaa56c34e486.png";